// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"305":"a5f634b8","465":"38cd49c5"}[chunkId] + ".chunk.css";
};